// marketing/campaignDisplay.js — v119.247 نصوص عرض موحّدة للحملات (واجهة).
// تعكس الدالة الموحّدة في الخادم: 0/0 ⇒ «بلا مهام»؛ الحالة عربية موحّدة.
export const STATUS_AR = {
  scheduled: "مجدولة",
  active: "نشطة",
  ended: "منتهية",
  draft: "مسودة",
  paused: "موقوفة",
  cancelled: "ملغاة",
};

// نسبة الإنجاز للعرض: «بلا مهام» عند غياب المهام، وإلا «pct%». لا 100% لـ0/0.
export const completionText = (c) =>
  (c && (c.no_tasks || c.progress_pct == null)) ? "بلا مهام" : `${c.progress_pct}%`;

export const statusText = (c) =>
  (c && (c.status_label || STATUS_AR[c.status])) || "—";

// «الوقت المنقضي» — عنوان عرض منفصل، لا يُسمّى إنجازًا.
export const elapsedText = (c) =>
  (c && c.time_elapsed_pct != null) ? `الوقت المنقضي ${c.time_elapsed_pct}%` : "";
